//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InTitle from "@/views/stencil/components/title";
import Editor from "@/views/stencil/components/editor";
import InstructionProtocol from "@/views/stencil/components/instructionProtocol";
import NewProtocol from "@/views/stencil/components/newProtocol";
import FixBottom from "../components/fixBottom";

import { getCheckCoupon } from "./index";
import { getFormatInfo } from "../index";

import { store, mutations } from "@/observable/store";
import mixinTxrNewWeb from "@/utils/mixin/mixinTxrNewWeb";
import mixinVerify from "@/utils/mixin/mixinVerify";
import Info from "./components/info";
import { CacheModule } from "@/utils/commonUtils";
import { loginIn } from "@/utils/loginIn.js";

export default {
	mixins: [mixinTxrNewWeb, mixinVerify],
	data() {
		return {
			// key: value
			institutionData: {
				categories: [],
				institutionName: "", //机构名称
			},
			formAlert: false,
			allData: {}, // 获取的数据
			protocolInfo: {},
			postFormData: {}, // 核保数据
			schemeCurrent: {}, // 方案
			inintH: "0rem",
			code: "", //验证码
			phone: "", //手机号
			lastPhone: "", //上次登录的手机号
		};
	},
	components: {
		InTitle,
		Editor,
		InstructionProtocol,
		NewProtocol,
		Info,
		FixBottom,
	},
	mounted() {
		this.STATISTICS_CONFIG.insur_proinfo_page();
		this.check();
		// 安卓定位顶起问题
		// if (this.IOS_AND == "Android") {
		// 	const documH = document.documentElement.clientHeight;
		// 	window.onresize = () => {
		// 		const currentH = document.documentElement.clientHeight;
		// 		if (documH - currentH > 0) {
		// 			this.inintH = -((documH - currentH) / 20 - 6) + "rem";
		// 		} else {
		// 			this.inintH = "0rem";
		// 		}
		// 	};
		// }

		this.$nextTick(() => {
			// 回溯视频
			this.postTX(this.channelCommodityCode);
		});
	},
	activated() {
		this.check();

		this.$nextTick(() => {
			// 回溯视频
			this.postTX(this.channelCommodityCode);
		});
	},
	beforeRouteEnter(to, from, next) {
		// 此页面需清除用户信息
		CacheModule.remove("userInfo");
		mutations.getsyToken("");
		mutations.getUid("");
		mutations.getPhone("");
		console.log("123");
		next();
	},
	computed: {
		// 渠道商品code
		channelCommodityCode() {
			return this.$route.query.commodityCode;
		},
		// 方案code
		schemeCode() {
			return this.$route.query.schemeCode;
		},
		name() {
			// 选中的项目
			return this.$route.query.name;
		},
		serviceList() {
			return (
				(this.allData.schemeServiceList &&
					this.allData.schemeServiceList[0].serviceList) ||
				[]
			);
		},
		uid() {
			//已登录用户的uid
			return store.uid;
		},
	},
	methods: {
		async check() {
			this.institutionData = await getCheckCoupon();
			console.log("res", this.institutionData);
			const data = {
				channelCommodityCode: this.channelCommodityCode,
				schemeCode: this.schemeCode,
			};
			// page/from 接口
			this.allData = await getFormatInfo(data);
			this.schemeCurrent = this.allData.schemes[0];
		},
		changeData(data) {
			// 核保数据
			this.postFormData = data.fromPageData;
			// 手机号
			this.phone = data.phone;
		},
		changeCode(code) {
			// 验证码
			this.code = code;
		},
		goback() {
			this.STATISTICS_CONFIG.insur_proinfo_changetype_click();
			this.$router.go(-1);
		},
		async receive() {
			if (this.formAlert) {
				this.STATISTICS_CONFIG.insur_proinfo_draw_popup_click();
				if (!this.phone) {
					this.$toast("请输入手机号");
					return false;
				}
				if (!this.code) {
					this.$toast("请输入验证码");
					return false;
				}
				// 确保用户已登录
				if (this.uid) {
					// 不同用户
					if (this.lastPhone != this.phone) {
						this.lastPhone = this.phone;
						loginIn({ phone: this.phone, code: this.code }).then((res) => {
							this.underwriting();
						});
						return false;
					}
					// 同一用户 去核保
					this.underwriting();
				} else {
					this.lastPhone = this.phone;
					loginIn({ phone: this.phone, code: this.code }).then((res) => {
						this.underwriting();
					});
				}
			} else {
				this.formAlert = true;
				this.STATISTICS_CONFIG.insur_proinfo_draw_nopopup_click();
			}
		},
		submitClick() {
			this.$refs.InstructionProtocol.selectFlag = true;
			this.receive();
		},
		underwriting() {
			// 默认只有一种方案
			let schemeCurrent = this.schemeCurrent;
			const data = {
				elements: this.postFormData,
				channelCommodityCode: this.channelCommodityCode,
				isFollow: this.allData.isFollow,
				originalPrice: schemeCurrent.originalPrice, // 划线价
				commodityPrice: schemeCurrent.commodityPrice,
				price: schemeCurrent.commodityPrice,
				traceId: store.TXoption.bizKey, // 回溯信息
				schemeCode: schemeCurrent.schemeCode, //方案code  目前只有一种
				secretKey: this.institutionData.secretKey, //卡密
				category: this.name, //类目
				ch: this.$route.query.ch || "",
			};
			console.log(data);
			this.protocolInfo = {
				productName: this.allData.commodityName,
				buyerName: this.postFormData["BUYER_NAME"].value,
				insuredName: this.postFormData["BUYER_NAME"].value,
			};
			// 统一核保
			this.verification(data)
				.then((res) => {
					// 创建订单
					this.mixinCreatAnOrder(() => {
						//领取成功
						this.$router.push({
							path: "/receiveResult",
							query: {
								state: 1,
								pid: this.$route.query.pid,
								ch: this.$route.query.ch,
							},
						});
					});
					this.STATISTICS_CONFIG.insur_insurinfoinput_submit_click({
						ex: { status: "pass" },
					});
				})
				.catch((res) => {
					this.STATISTICS_CONFIG.insur_insurinfoinput_submit_click({
						ex: { status: "fail" },
					});
				});
		},
	},
};
